module.exports = XLSX;